import { getLocale } from "../runtime";

const sv_loadmoreitems = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ladda fler`
};

const loadmoreitems = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_loadmoreitems(inputs)
	return "loadMoreItems";
};

export { loadmoreitems as "loadMoreItems" };